var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsDontFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 37.6667C5 20.1772 19.1772 6 36.6667 6C54.1562 6 68.3333 20.1772 68.3333 37.6667C68.3333 55.1562 54.1562 69.3333 36.6667 69.3333C19.1772 69.3333 5 55.1562 5 37.6667Z",
    fill: "#ECECF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7288 44.7288L50 51M43.7288 44.7288C39.2156 49.2422 31.8982 49.2422 27.385 44.7288C22.8717 40.2156 22.8717 32.8982 27.385 28.385C31.8982 23.8717 39.2156 23.8717 43.7288 28.385C48.2422 32.8982 48.2422 40.2156 43.7288 44.7288Z",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1571 33.1568C32.3195 32.9944 32.54 32.9033 32.7696 32.9033C32.9992 32.9034 33.2198 32.9944 33.3821 33.1568L35.0311 34.8058L36.6801 33.1568C36.8425 32.9944 37.063 32.9033 37.2926 32.9033C37.5222 32.9034 37.7428 32.9944 37.9051 33.1568C38.0674 33.3192 38.1586 33.5396 38.1586 33.7693C38.1585 33.9989 38.0675 34.2194 37.9051 34.3818L36.2561 36.0308L37.9051 37.6798C38.0675 37.8422 38.1585 38.0626 38.1586 38.2923C38.1586 38.5219 38.0674 38.7424 37.9051 38.9048C37.7428 39.0671 37.5222 39.1581 37.2926 39.1582C37.063 39.1582 36.8425 39.0671 36.6801 38.9048L35.0311 37.2558L33.3821 38.9048C33.2198 39.0671 32.9992 39.1581 32.7696 39.1582C32.54 39.1582 32.3195 39.0671 32.1571 38.9048C31.9947 38.7423 31.9037 38.522 31.9037 38.2923C31.9037 38.0626 31.9947 37.8422 32.1571 37.6798L33.8061 36.0308L32.1571 34.3818C31.9947 34.2194 31.9037 33.999 31.9037 33.7693C31.9037 33.5396 31.9947 33.3192 32.1571 33.1568Z",
    fill: "#0D0D0D",
    stroke: "#ECECF1",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsDontFound);
export default __webpack_public_path__ + "static/media/documentsDontFound.0622d1c89a0ea2e7515b45c269641a87.svg";
export { ForwardRef as ReactComponent };